import type { SelectionTileToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useSelectionTileTokens = (theme: Theme): SelectionTileToken => {
  const { color, borderRadius, component } = theme;
  const base = {
    borderColor: color.outline,
    borderRadius: borderRadius.xl,
    hoverBorderColor: color.outline,
    hoverBackgroundColor: color.surfaceContainer,
    subtitleColor: color.onSurfaceVariant,
  };

  return merge({}, base, component?.selectionTile) as SelectionTileToken;
};
